/**
 * Hub: only hub-scoped rows (null incidentId). Incident workspace: hub rows
 * plus that incident's rows. Matches UscgMapContext map-sync filtering.
 */
export function isExternalLayerInCurrentScope(
  layer: { incidentId?: string | null },
  incidentFilterId: string | null | undefined
): boolean {
  if (incidentFilterId) {
    return !layer.incidentId || layer.incidentId === incidentFilterId;
  }
  return !layer.incidentId;
}
